export default __webpack_public_path__ + "static/media/633.aa7c852e.jpg";